<template>
  <el-dialog :visible.sync="deleteDialogVisible" center width="550px" title="请输入秘钥" :before-close="beforeCloseDelete">
    <el-form ref="form1" :model="form1" :rules="formRules1"
      style="margin-top: 10px;display:flex;justify-content: center;">
      <el-form-item label="" style="margin-bottom: 10px;" prop="password">
        <el-input class="width_short" placeholder="请输入" v-model="form1.password" type="password"></el-input>
        <div style="color: grey; margin: 0 10px; opacity: 0.8">删除后，将解除课程与学科的关联关系</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="beforeCloseDelete">取 消</el-button>
      <el-button type="primary" @click="confirmDeleteHandle
      ">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script scoped>
export default {
  name: 'deleteConfirm',
  props: ['deleteDialogVisible'],
  data() {
    return {
      deletePassword: 'ibaby123456789',
      form1: {
        id: '',
        password: ''
      },
      formRules1: {
        password: { required: true, message: '请输入秘钥', trigger: 'blur' }
      }
    }
  },
  methods: {
    confirmDeleteHandle() {
      this.$refs.form1.validate(valid => {
        if (valid) {
          if (this.form1.password !== this.deletePassword) {
            this.$message.error('秘钥输入不正确，请重新输入')
            return;
          }
          this.form1.id = ''
          this.form1.password = '';
          this.$emit('confirmDeleteHandle');
        }
      })
    },
    beforeCloseDelete() {
      this.form1.id = ''
      this.form1.password = '';
      this.$refs.form1.clearValidate();
      this.$emit('closeHandle');
      this.$message.info('已取消删除');
    },
  }
};
</script>

<style type="text/less" lang="less" scoped></style>


// WEBPACK FOOTER //
// src/components/deleteConfirm.vue